import { Header } from "../components/Header";
import SideNavigation from "../components/SideNavigation";
import { Outlet } from "react-router-dom";
function AppLayout() {
  return (
    <div>
      <Header />
      <SideNavigation />
      <Outlet />
    </div>
  );
}

export default AppLayout;
